import { Injectable } from "@angular/core";
import { CacheService } from "@apps/patient-core/src/app/services/cache.service";
import { CachedHttpService } from "@apps/patient-core/src/app/services/cached-http.service";
import { BaseCommonService } from "@apps/patient-core/src/app/services/abstracts/common.service";
import { FeatureFlagsService } from "@apps/patient-core/src/app/services/feature-flags.service";
import { GAService } from "@apps/patient-core/src/app/services/ga.service";
import { LocalisationService } from "@apps/patient-core/src/app/services/localisation.service";
import { LocationService } from "@apps/patient-core/src/app/services/location.service";
import { NavigationService } from "@apps/patient-core/src/app/services/navigation.service";
import { InactivityMonitorService } from "../inactivity-monitor.service";
import { BaseAuthService } from "@apps/patient-core/src/app/services/abstracts/auth.service";
import { BaseBrandService } from "@apps/patient-core/src/app/services/abstracts/brand.service";
import { BasePatientsService } from "@apps/patient-core/src/app/services/abstracts/patients.service";

@Injectable({
  providedIn: "root",
})
export class PatientCommonService extends BaseCommonService {
  constructor(
    _brandService: BaseBrandService,
    _patientsService: BasePatientsService,
    _authService: BaseAuthService,
    _gaService: GAService,
    _cacheService: CacheService,
    _locationService: LocationService,
    _featureFlagsService: FeatureFlagsService,
    _navigationService: NavigationService,
    _cachedHttpService: CachedHttpService,
    _localisationService: LocalisationService,
    private _inactivityMonitorService: InactivityMonitorService
  ) {
    super(
      _brandService,
      _patientsService,
      _authService,
      _gaService,
      _cacheService,
      _locationService,
      _featureFlagsService,
      _navigationService,
      _cachedHttpService,
      _localisationService
    );
  }

  protected _handleDomainInfo200(graphData: any, pathname: string): void {
    const forceSwap = pathname === "/login/redirect";
    this._authService.setPublicToken(graphData.public_jwt, forceSwap);
    super._handleDomainInfo200(graphData, pathname);
    this._inactivityMonitorService.start();
  }

  protected get allowAutocomplete(): boolean {
    return true;
  }
}
